import { IDefaultContabilResponse } from "@/features/contabil/services/types";
import {
  IControleDebitosGateway,
  IControleDebitosResponse
} from "../ports/ControleDebitosGateway";
import {
  type HttpClient,
  HttpStatusCode
} from "@/core/services/protocols/types";
import ControleDebitosGatewayError from "../errors/ControleDebitosGatewayError";
import { inject, injectable } from "inversify";
import "reflect-metadata";
import { DITypes } from "@/core/@types/types";

@injectable()
export default class ControleDebitosGatewayAdapter
  implements IControleDebitosGateway
{
  @inject(DITypes.CONTABIL_HTTP_CLIENT)
  http!: HttpClient;

  async get(): Promise<IControleDebitosResponse> {
    const request = await this.http.get<
      IDefaultContabilResponse<IControleDebitosResponse>
    >({
      url: "v1/dashboard/geral/debitospgdas"
    });

    if (request.statusCode !== HttpStatusCode.success)
      throw new ControleDebitosGatewayError();

    return request.body?.result || { debitosEmpresa: [] };
  }
}
